<template>
  	<div class="d-inline-flex flex-column mx-auto w-100">
  		<p :class="statusType !== 'expired' ? 'mb-3' : 'mb-0'" class="font-weight-semibold small text-uppercase text-center">{{ message }}</p>
	    <div v-if="statusType !== 'expired'" class="d-inline-flex mx-auto">
	      <div class="d-flex flex flex-column align-items-center justify-content-center py-3 w-20 mx-1 mx-md-2 bg-light">
	        <span class="h2 font-weight-normal leading-none">{{ days }}</span>
	        <div class="d-block font-weight-light leading-none text-uppercase small text-gray">{{ wordString.day }}</div>
	      </div>
	      <div class="d-flex flex flex-column align-items-center justify-content-center py-3 w-20 mx-1 mx-md-2 bg-light">
	        <span class="h2 font-weight-normal leading-none">{{ hours }}</span>
	        <div class="d-block font-weight-light leading-none text-uppercase small text-gray">{{ wordString.hours }}</div>
	      </div>
	      <div class="d-flex flex flex-column align-items-center justify-content-center py-3 w-20 mx-1 mx-md-2 bg-light">
	        <span class="h2 font-weight-normal leading-none">{{ minutes }}</span>
	        <div class="d-block font-weight-light leading-none text-uppercase small text-gray">{{ wordString.minutes }}</div>
	      </div>
	      <div class="d-flex flex flex-column align-items-center justify-content-center py-3 w-20 mx-1 mx-md-2 bg-light">
	        <span class="h2 font-weight-normal leading-none">{{ seconds }}</span>
	        <div class="d-block font-weight-light leading-none text-uppercase small text-gray">{{ wordString.seconds }}</div>
	      </div>
	  	</div>
    </div>
</template>

<script>
	export default {
	  props: {
	  	starttime: {
	  		required: true
	  	},
	  	endtime: {
	  		required: true
	  	},
	  	trans: {
	  		required: true
	  	}
	  },
	  data: function(){
	  	return {
			timer: "",
			wordString: {},
			start: "",
			end: "",
			interval: "",
			days: "",
			minutes: "",
			hours: "",
			seconds: "",
			message: "",
			statusType: "",
			statusText: "",
	    };
	  },
	  created: function () {
	        this.wordString = JSON.parse(this.trans);
	    },
	  mounted(){
	    this.start = this.starttime;
	    this.end = this.endtime;
	    // Update the count down every 1 second
	    this.timerCount(this.start,this.end);
	    this.interval = setInterval(() => {
	        this.timerCount(this.start,this.end);
	    }, 1000);
	  },
	  methods: {
	    timerCount: function(start,end){
	        // Get todays date and time
	        var now = new Date().getTime();

	        // Find the distance between now an the count down date
	        var distance = start - now;
	        var passTime =  end - now;

	        if(distance < 0 && passTime < 0){
	            this.message = this.wordString.expired;
	            this.statusType = "expired";
	            this.statusText = this.wordString.status.expired;
	            clearInterval(this.interval);
	            return;

	        }else if(distance < 0 && passTime > 0){
	            this.calcTime(passTime);
	            this.message = this.wordString.running;
	            this.statusType = "running";
	            this.statusText = this.wordString.status.running;

	        } else if( distance > 0 && passTime > 0 ){
	            this.calcTime(distance); 
	            this.message = this.wordString.upcoming;
	            this.statusType = "upcoming";
	            this.statusText = this.wordString.status.upcoming;
	        }
	    },
	    calcTime: function(dist){
	      // Time calculations for days, hours, minutes and seconds
	        this.days = Math.floor(dist / (1000 * 60 * 60 * 24));
	        this.hours = Math.floor((dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
	        this.minutes = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60));
	        this.seconds = Math.floor((dist % (1000 * 60)) / 1000);
	    }
	}
}
</script>


// WEBPACK FOOTER //
// src/components/Countdown.vue